import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import enGB from './translations/en-GB.json';
import enUS from './translations/en-US.json';
import config from './config';

i18n.use(initReactI18next).init({
  fallbackLng: config.locale,
  debug: true,
  interpolation: { escapeValue: false },
  nonExplicitSupportedLngs: true,
  saveMissing: true,
  returnNull: false,
  returnEmptyString: false,
  // missingKeyHandler(lng, ns, key) {
  //   console.warn(`Missing translation for key: "${key}" in language "${lng}"`);
  // },
  parseMissingKeyHandler: (key) => {
    return `🚨 ${key} 🚨`;
  },
  resources: {
    'en-GB': {
      translation: enGB
    },
    'en-US': {
      translation: enUS
    }
  }
});

export default i18n;
